module.exports = __webpack_public_path__ + "static/contact_img-ef5f8f1015eb15dae747edc907241041.png";